import state from './state'
import gettersBase from './getters-base'
import gettersShipper from './getters-shipper'
import actionsBase from './actions-base'
import actionsDriver from './actions-driver'
import mutationsBase from './mutations-base'

const pluginName = 'starhouse-data-store'
const defaultNamespace = 'sh'

// Merge all store modules
const getters = Object.assign({}, gettersBase, gettersShipper)
const actions = Object.assign(actionsBase, actionsDriver)

const dataStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: mutationsBase
}

export default function install (Vue, options = {}) {
  // Parse options
  const logInit = options.logInit && options.logInit === true
  // const debug = options.debug && options.debug === true
  // const debugRequests = options.debugRequests && options.debugRequests === true
  // const debugNormalizer = options.debugNormalizer && options.debugNormalizer === true
  const namespace = options.namespace || defaultNamespace
  const dataForms = options.dataForms
  // const apiSettings = options.api || {}
  // const userSettings = options.user || {}
  // const resources = options.resources || []
  // const clearDataOn = options.clearDataOn
  // const initSettings = {
  //   apiSettings: objectUtils.cloneDeep(apiSettings),
  //   userSettings: objectUtils.cloneDeep(userSettings),
  //   resources,
  // }

  if (logInit) console.log(`Vue is being bootstrapped with "${pluginName}", using namespace: ${namespace}`)

  // Bootstrap vuex
  if (options.store) {
    // const dataStore = generateStore({
    //   debug,
    //   debugInit,
    //   debugRequests,
    //   debugNormalizer,
    //   pluginName,
    //   initSettings,
    // })
    options.store.registerModule(namespace, dataStore)

    // Attach store subscriptions
    // if (clearDataOn) {
    //   const clearDataTrigger = clearDataOn || '_'
    //   options.store.subscribe(({ type }) => {
    //     switch (type) {
    //       case clearDataTrigger:
    //         if (debug) console.log(`[${pluginName}] Triggered clear data on:`, clearDataTrigger)
    //         options.store.dispatch('cms/clearData', { mine: true, editing: true, previewing: true })
    //         break
    //     }
    //   })
    // }
  } // end-if (options.store)

  // Register custom data forms
  if (dataForms) {
    Object.entries(dataForms).forEach(([resource, forms]) => {
      if (forms && Array.isArray(forms) && forms.length > 0) {
        forms.forEach((form) => {
          const editFormName = form.name
          if (logInit) console.log(`[${pluginName}] ---> Registering custom data form "${editFormName}" for resource "${resource}"`)
          Vue.component(editFormName, form)
        })
      }
    })
  }
}
